<template>
  <div class="cs-row">
    <div class="puzzle-box">
      <div class="show-txt show-left">{{ $t("peopleBoardWhat") }}</div>
      <Row class="patentialRow" v-for="(item, index) in data" :key="index">
        <Col span="3"
          ><span>{{
            lang == "zh" ? item.scopeType : item.enScopeType
          }}</span></Col
        >
        <Col span="4" v-for="num in legendData.length" :key="num + '-bg'">
          <div
            class="potentialBox"
            :style="{ background: getBackground(index, num) }"
            @click="showInfoClick(item, num, index)"
          >
            {{ getName(item, num) }}
          </div>
        </Col>
      </Row>
      <Row class="patentialRow">
        <Col span="3"></Col>
        <Col
          span="4"
          v-for="(legend, lIndex) in legendRowData"
          :key="lIndex + '-legend-row'"
          >{{ legend.name }}</Col
        >
      </Row>
    </div>
    <div class="legend-box">
      <span class="legend-title">{{ $t("peopleScoreTxt") }}</span>
      <div
        class="legend-row"
        v-for="(legend, lIndex) in legendData"
        :key="lIndex + '-legend'"
      >
        <div
          class="legend-item"
          :style="{ background: getLegendBg(lIndex + 1) }"
        ></div>
        {{ legend.name }}
      </div>
      <div class="show-txt show-right">{{ $t("peopleBoardHow") }}</div>
    </div>
    <Modal v-model="showinfoModal" title="员工信息" width="400px">
      <div class="modalListBox">
        <List :header="$t('Name')" border size="small">
          <ListItem v-for="(item, index) in dataListName" :key="index">
            <ListItemMeta>
              <template slot="title">
                <div style="display: flex; align-items: center">
                  {{ item.userName
                  }}<Icon
                    v-if="
                      item.serialnumber == '0001' || item.serialnumber == '1002'
                    "
                    type="md-star"
                    size="12"
                    color="#ffb400"
                  />
                </div>
              </template>
            </ListItemMeta>
            <template slot="action">
              <li>
                <span style="color: #459846" @click="moredetil(item)"
                  ><!-- 更多 -->{{ $t("Select_More") }}</span
                >
              </li>
            </template>
          </ListItem>
        </List>
      </div>
      <Spin size="large" fix v-if="modalSpinShow"></Spin>
      <div slot="footer">
        <Button @click="showinfoModal = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dataListName: [],
      showinfoModal: false,
      modalSpinShow: false,
      data: [],
      allData: [],
      bg1: "#375623",
      bg2: "#00B050",
      bg3: "#A9D08E",
      bg4: "#FFE699",
      bg5: "#d9d9d9",
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    legendRowData() {
      let arr = [
        {
          name: this.$t("PBScoreOne"), //需要改善
        },
        {
          name: this.$t("PBScoreTwo"), //部分达标
        },
        {
          name: this.$t("PBScoreThree"), //达到要求
        },
        {
          name: this.$t("PBScoreFour"), //超越要求
        },
        {
          name: this.$t("PBScoreFive"), //优秀出色
        },
      ];
      return arr;
    },
    legendData() {
      let arr = JSON.parse(JSON.stringify(this.legendRowData));
      return arr.reverse();
    },
  },
  methods: {
    getName(item, num) {
      return item["achNormal" + num];
    },
    getLegendBg(index) {
      return this["bg" + index];
    },
    getBackground(rowIndex, colIndex) {
      let bg1 = this.bg1;
      let bg2 = this.bg2;
      let bg3 = this.bg3;
      let bg4 = this.bg4;
      let bg5 = this.bg5;
      let bgColor = "";
      if (rowIndex == 0) {
        bgColor = bg1;
        if (colIndex == 1) {
          bgColor = bg4;
        }
        if (colIndex == 2) {
          bgColor = bg3;
        }
        if (colIndex == 3) {
          bgColor = bg2;
        }
      }
      if (rowIndex == 1) {
        bgColor = bg3;
        if (colIndex == 1) {
          bgColor = bg4;
        }
        if (colIndex == 4) {
          bgColor = bg2;
        }
        if (colIndex == 5) {
          bgColor = bg1;
        }
      }
      if (rowIndex == 2) {
        bgColor = bg3;
        if ([1, 2].includes(colIndex)) {
          bgColor = bg4;
        }
        if ([4, 5].includes(colIndex)) {
          bgColor = bg2;
        }
      }
      if (rowIndex == 3) {
        bgColor = bg3;
        if ([1].includes(colIndex)) {
          bgColor = bg5;
        }
        if ([2].includes(colIndex)) {
          bgColor = bg4;
        }
      }
      if (rowIndex == 4) {
        if ([1, 2].includes(colIndex)) {
          bgColor = bg5;
        }
        if ([3, 4, 5].includes(colIndex)) {
          bgColor = bg4;
        }
      }

      return bgColor;
    },
    showInfoClick(item, colIndex, rowIndex) {
      this.showinfoModal = true;
      this.modalSpinShow = true;
      let obj = {
        allData: this.allData,
        howScore: colIndex,
        whatScore: item.scopeType,
      };

      axios
        .post("/achReport/selectTwentyFiveTableLeftData", obj)
        .then((res) => {
          this.modalSpinShow = false;
          if (res) {
            this.dataListName = res;
          }
        });
    },
    moredetil(row) {
      this.$router.push({
        path: "/090E24C0B112F54B073978E64390DDE1/A3FFBEBFDB713E27",
        query: {
          id: this.$route.query.id,
          beEnd: this.$route.query.beEnd,
          serialnumber: row.serialnumber,
        },
      });
      // query: { serialnumber:row.serialnumber} })
    },
  },
};
</script>


<style lang="less" scoped>
.cs-row {
  display: flex;
}
.puzzle-box {
  width: 90%;
  padding-top: 40px;
}
.legend-box {
  width: 10%;
  text-align: right;
  position: relative;
}
.show-txt {
  font-weight: bold;
  font-size: 20px;
  position: absolute;
}
.show-left {
  left: 5%;
  top: 50px;
  color: #375623;
}
.show-right {
  left: -30px;
  bottom: 40px;
  color: #16a761;
}
.legend-row {
  display: flex;
  align-items: center;
}
.legend-title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 20px;
}
.legend-item {
  width: 30px;
  height: 28px;
  border: 1px solid #ededed;
  margin-right: 10px;
  margin-bottom: 10px;
}
.patentialRow {
  margin-top: 8px;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  span {
    display: block;
    text-align: right;
    margin-right: 20px;
  }
}
.potentialBox {
  width: 96%;
  height: 120px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  line-height: 120px;
  text-align: center;
  cursor: pointer;
  font-size: 22px;
  color: #fff;
}
.potentialBox:hover {
  opacity: 0.5;
}
.modalListBox {
  max-height: 500px;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/AchAssessComponentProportion2.vue